import { debounceRAF } from "../utils/timing";

export class ScrollOnePageSpy {

    constructor(spySelector, navSelector) {


        this.sections = [...document.querySelectorAll(spySelector)];
        this.links = [...document.querySelectorAll(navSelector)];

        const observer = new IntersectionObserver((entries) => {

            // - Keep only visible ones
            const visible = entries.filter(e => e.isIntersecting);

            // console.log(visible);

            // - Keep the nearest
            visible.sort((a, b) => b.intersectionRatio - a.intersectionRatio);

            if (visible[0]) {

                this.setNavLineActive(visible[0].target.id);

            }

        }, {
            root: null,
            rootMargin: "-30% 0px -30% 0px",
            threshold: 0
        });

        this.sections.forEach(s => observer.observe(s));

    }

    setNavLineActive = (id) => {

        this.links.forEach(a => {

            // console.log(a.hash === `#${id}`, id, a.hash);
            
            if (a.hash === `#${id}`) {

                a.setAttribute('aria-current', 'section');

            } else {

                a.removeAttribute('aria-current');

            }
            
        });

    }

}
